import CircleIcon from '@mui/icons-material/Circle';
import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export default function WhatsNext({ isSuccess, unpaidCount }) {
  return (
    <Stack gap={2}>
      <Text size="lg" weight="bold">
        <FormattedMessage id="dashboard.paymentReturn.whatsNext.title" />
      </Text>
      <Stack gap={1.5}>
        <Stack direction="row" gap={1.5} alignItems="center">
          <CircleIcon sx={{ width: 8, height: 8, color: 'text.secondary' }} />
          <Text size="sm" color="secondary">
            {isSuccess
              ? <FormattedMessage id="dashboard.paymentReturn.whatsNext.noUnpaid" />
              : (
                <FormattedMessage
                  id="dashboard.paymentReturn.whatsNext.hasUnpaid"
                  values={{ unpaidCount }}
                />
              )}
          </Text>
        </Stack>
        <Stack direction="row" gap={1.5} alignItems="center">
          <CircleIcon sx={{ width: 8, height: 8, color: 'text.secondary' }} />
          <Text size="sm" color="secondary">
            <FormattedMessage id="dashboard.paymentReturn.whatsNext.servicesActive" />
          </Text>
        </Stack>
      </Stack>
    </Stack>
  );
}

WhatsNext.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  unpaidCount: PropTypes.number.isRequired
};
